import { render, staticRenderFns } from "./BlockImageLeftTextRight.vue?vue&type=template&id=4f84478f&"
import script from "./BlockImageLeftTextRight.vue?vue&type=script&lang=js&"
export * from "./BlockImageLeftTextRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports